import { gql } from '@/__generated__/gql';

export const LIST_PLATFORM_MANAGER_USERS_QUERY = gql(`
  query FatSettingsPageListPlatformManagerUsers($filters: ListUsersWithPaginationFilterDto) {
    listPlatformManagerUsers(filters: $filters) {
      total
      page
      perPage
      data {
        id
        firstName
        lastName
        initials
        email
        officePhoneNumber {
          countryCode
          number
        }
        mobilePhoneNumber {
          countryCode
          number
        }
        lastLogin
        deletedAt
        roles
        tenant {
          id
          name
          type
        }
        impersonated {
          email
          firstName
          lastName
          tenantName
          originalUser {
            email
            firstName
            lastName
            tenantName
          }
        }
        timezone
        emailNotifications
        title
        supervisorId
        isFinalUser
      }
    }
  }
`);

export const LIST_ADVISORY_FIRM_USERS_QUERY = gql(`
  query FatSettingsPageListAdvisoryFirmUsers($filters: ListUsersWithPaginationFilterDto!) {
    listAdvisoryFirmUsers(filters: $filters) {
      total
      page
      perPage
      data {
        id
        firstName
        lastName
        initials
        email
        officePhoneNumber {
          countryCode
          number
        }
        mobilePhoneNumber {
          countryCode
          number
        }
        lastLogin
        deletedAt
        roles
        tenant {
          id
          name
          type
        }
        impersonated {
          email
          firstName
          lastName
          tenantName
          originalUser {
            email
            firstName
            lastName
            tenantName
          }
        }
        timezone
        emailNotifications
        title
        supervisorId
        isFinalUser
      }
    }
  }
`);

export const CREATE_USER_MUTATION = gql(`
  mutation FatSettingsPageCreateUser($data: CreateUserInput!) {
    createUser(data: $data) {
      id
      firstName
      lastName
      initials
      email
      officePhoneNumber {
        countryCode
        number
      }
      mobilePhoneNumber {
        countryCode
        number
      }
      lastLogin
      deletedAt
      roles
      tenant {
        id
        name
        type
      }
      impersonated {
        email
        firstName
        lastName
        tenantName
        originalUser {
          email
          firstName
          lastName
          tenantName
        }
      }
      timezone
      emailNotifications
      title
    }
  }
`);

export const UPDATE_USER_MUTATION = gql(`
  mutation FatSettingsPageUpdateUser($data: UpdateUserInput!) {
    updateUser(data: $data) {
      id
    }
  }
`);

export const SEND_UPDATE_USER_EMAIL_ADDRESS_EMAIL_MUTATION = gql(`
  mutation FatSettingsPageSendUpdateUserEmailAddressEmail($data: UpdateUserSendEmailInput!) {
    sendUpdateUserEmailAddressEmail(data: $data)
  }
`);

export const UPDATE_USER_EMAIL_MUTATION = gql(`
  mutation FatSettingsPageUpdateUserEmail($data: UpdateUserEmailInput!) {
    updateUserEmail(data: $data) {
      id
    }
  }
`);

export const SEND_WELCOME_EMAIL_MUTATION = gql(`
  mutation FatSettingsPageSendWelcomeEmail($data: UserWelcomeEmailInput!) {
    sendWelcomeEmail(data: $data)
  }
`);

export const TOGGLE_USER_STATUS_MUTATION = gql(`
  mutation FatSettingsPageToggleUserStatus($userId: String!) {
    toggleUserStatus(userId: $userId) {
      id
    }
  }
`);

export const DELETE_USER_MUTATION = gql(`
  mutation FatSettingsPageDeleteUser($data: DeleteUserInput!) {
    deleteUser(data: $data) {
      id
    }
  }
`);

export const SEND_RESET_PASSWORD_EMAIL_MUTATION = gql(`
  mutation FatSettingsPageSendResetPasswordEmail($email: String!) {
    sendResetPasswordEmail(email: $email)
  }
`);

export const MAKE_PRIMARY_ADMIN_MUTATION = gql(`
  mutation FatSettingsPageMakePrimaryAdmin($id: String!) {
    makePrimaryAdmin(id: $id) {
      id
    }
  }
`);
